import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/layouts/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Info = makeShortcode("Info");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Info mdxType="Info">
  Uniswap V1, while still fully functional, is no longer under active development. Looking for <Link style={{
        display: "contents"
      }} to='/docs/v2/' mdxType="Link">V2 documentation</Link>?
    </Info>
    <p>{`Uniswap V1 is the first version of the protocol, `}<a parentName="p" {...{
        "href": "https://twitter.com/haydenzadams/status/1058376395108376577"
      }}>{`launched in November 2018`}</a>{` at Devcon 4. Because of its permissionless nature, it will exist for as long as Ethereum does. However, V2 includes a number of tangible improvements over V1. You are invited to explore the `}<Link to='/docs/v2/' mdxType="Link">{`V2 documentation`}</Link>{`.`}</p>
    <p>{`Designed with simplicity in mind, the Uniswap protocol provides an interface for seamless exchange of ERC20 tokens on Ethereum. By eliminating unnecessary forms of rent extraction and middlemen it allows faster, more efficient exchange. Where it makes tradeoffs, decentralization, censorship resistance, and security are prioritized.`}</p>
    <p>{`Uniswap is open source and functions as a public good. There is no central token or platform fee. No special treatment is given to early investors, adopters, or developers. Token listing is open and free. All smart contract functions are public and all upgrades are opt-in.`}</p>
    <p>{`This site will serve as a project overview for Uniswap - explaining how it works, how to use it, and how to build on top of it. These docs are actively being worked on and more information will be added on an ongoing basis.`}</p>
    <h1 {...{
      "id": "v1-features",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#v1-features",
        "aria-label": "v1 features permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`V1 Features`}</h1>
    <ul>
      <li parentName="ul">{`Add support for any ERC20 token using the Uniswap `}<a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-v1/blob/master/contracts/uniswap_factory.vy"
        }}>{`factory`}</a></li>
      <li parentName="ul"><Link to='/docs/v1/frontend-integration/pool-liquidity/#add-liquidity' mdxType="Link">Join liquidity pools</Link> to collect fees on ETH-ERC20 pairs</li>
      <li parentName="ul">{`Liquidity-sensitive automated pricing using `}<a parentName="li" {...{
          "href": "https://github.com/runtimeverification/verified-smart-contracts/blob/uniswap/uniswap/x-y-k.pdf"
        }}>{`constant product formula`}</a></li>
      <li parentName="ul">{`Trade `}<Link to='/docs/v1/frontend-integration/trade-tokens' mdxType="Link">{`ETH for any ERC20`}</Link>{` without wrapping`}</li>
      <li parentName="ul">{`Trade `}<Link to='/docs/v1/frontend-integration/trade-tokens' mdxType="Link">{`any ERC20 for any ERC20`}</Link>{` in a single transaction`}</li>
      <li parentName="ul">{`Trade and transfer to a different address in a single transaction`}</li>
      <li parentName="ul">{`Lowest gas cost of any decentralized exchange`}</li>
      <li parentName="ul">{`Support for private and custom uniswap exchanges`}</li>
      <li parentName="ul">{`Buy ERC20 tokens from any wallet using ENS`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/runtimeverification/verified-smart-contracts/tree/uniswap/uniswap"
        }}>{`Partially verified`}</a>{` smart contracts written in Vyper`}</li>
      <li parentName="ul">{`Mobile-optimized open source `}<a parentName="li" {...{
          "href": "https://github.com/Uniswap/uniswap-interface"
        }}>{`frontend implementation`}</a></li>
      <li parentName="ul">{`Funded through an `}<a parentName="li" {...{
          "href": "https://blog.ethereum.org/2018/08/17/ethereum-foundation-grants-update-wave-3/"
        }}>{`Ethereum Foundation grant`}</a></li>
    </ul>
    <h1 {...{
      "id": "resources",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#resources",
        "aria-label": "resources permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Resources`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://uniswap.org"
        }}>{`Website`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Uniswap"
        }}>{`GitHub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://twitter.com/Uniswap"
        }}>{`Twitter`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.reddit.com/r/Uniswap"
        }}>{`Reddit`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "mailto:contact@uniswap.org"
        }}>{`Email`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://hackmd.io/s/HJ9jLsfTz"
        }}>{`Whitepaper`}</a></li>
    </ul>
    <h1 {...{
      "id": "how-it-works",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#how-it-works",
        "aria-label": "how it works permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`How it works`}</h1>
    <p>{`Uniswap is made up of a series of ETH-ERC20 exchange contracts. There is exactly one exchange contract per ERC20 token. If a token does not yet have an exchange it can be created by anyone using the Uniswap factory contract. The factory serves as a public registry and is used to look up all token and exchange addresses added to the system.`}</p>
    <p>{`Each exchange holds reserves of both ETH and its associated ERC20 token. Anyone can become a liquidity provider on an exchange and contribute to its reserves. This is different than buying or selling; it requires depositing an equivalent value of both ETH and the relevant ERC20 token. Liquidity is pooled across all providers and an internal “pool token” (ERC20) is used to track each providers relative contribution. Pool tokens are minted when liquidity is deposited into the system and can be burned at any time to withdraw a proportional share of the reserves.`}</p>
    <p>{`Exchange contracts are automated market makers between an ETH-ERC20 pair. Traders can swap between the two in either direction by adding to the liquidity reserve of one and withdrawing from the reserve of the other. Since ETH is a common pair for all ERC20 exchanges, it can be used as an intermediary allowing direct ERC20-ERC20 trades in a single transaction. Users can specify a recipient address if they want to receive purchased tokens at a different address from the one used to make a transaction.`}</p>
    <p>{`Uniswap uses a “constant product” market making formula which sets the exchange rate based off of the relative size of the ETH and ERC20 reserves, and the amount with which an incoming trade shifts this ratio. Selling ETH for ERC20 tokens increases the size of the ETH reserve and decreases the size of the ERC20 reserve. This shifts the reserve ratio, increasing the ERC20 token’s price relative to ETH for subsequent transactions. The larger a trade relative to the total size of the reserves, the more price slippage will occur. Essentially, exchange contracts use the open financial market to decide on the relative value of a pair and uses that as a market making strategy.`}</p>
    <p>{`A small liquidity provider fee `}{`(`}{`0.30%`}{`)`}{` is taken out of each trade and added to the reserves. While the ETH-ERC20 reserve ratio is constantly shifting, fees makes sure that the total combined reserve size increases with every trade. This functions as a payout to liquidity providers that is collected when they burn their pool tokens to withdraw their portion of total reserves. Guaranteed arbitrage opportunities from price fluctuations should push a steady flow of transactions through the system and increase the amount of fee revenue generated.`}</p>
    <p>{`Since Uniswap is entirely on-chain, prices can change between when a transaction is signed and when it is included in a block. Traders can bound price fluctuations by specifying the minimum amount bought on sell orders, or the maximum amount sold on buy orders. This acts as a limit order that will automatically cancel if it is not filled. It is also possible to set transaction deadlines which will cancel orders if they are not executed fast enough.`}</p>
    <p>{`The reason only one exchange per token can be registered to the factory is to encourage providers to pool their liquidity into a single reserve. However, Uniswap has built in support for ERC20-to-ERC20 trades using the public pools from the factory on one side of the transaction and custom, user-specified pool on the other. Custom pools could have fund managers, use alternate pricing mechanisms, remove liquidity provider fees, integrate complex three dimensional fomo-based ponzi-schemes and more. They just need to implement the Uniswap interface and accept ETH as an intermediary asset. Custom pools do not have the same safety properties as the public ones. It is recommended users only interact with audited, open-source smart contracts.`}</p>
    <p>{`Upgrading censorship resistant, decentralized smart contracts is difficult. If significant improvements are made to the system a new version will be released. Liquidity providers can choose between moving to the new system or staying in the old one. If possible, new versions will be backwards compatible and able to trade ERC20-to-ERC20 with the old versions similar to a custom pool.`}</p>
    <h1 {...{
      "id": "how-to-use-it",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#how-to-use-it",
        "aria-label": "how to use it permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`How to use it`}</h1>
    <p><a parentName="p" {...{
        "href": "https://uniswap.org"
      }}>{`uniswap.org`}</a>{` is the landing page for the Uniswap protocol. It describes the project and directs users where they need to go.`}</p>
    <p>{`The Uniswap smart contracts live on Ethereum. Anyone can interact with them directly.`}</p>
    <p>{`The Uniswap frontend is an open source interface designed to improve user experience when interacting with the smart contracts. Anyone can use the source code to host an interface, or build their own. Hosted interfaces are independent of Uniswap, and should comply with their jurisdictional laws and regulations.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      